/** Ajuda — Impulsione suas Vendas: promoções, cupons, campanhas, avaliações. */
export const marketing = {
  id: "marketing",
  titulo: "Promoções, cupons e campanhas",
  icone: "Megaphone",
  intro: "As ferramentas de venda: promoções no cardápio, cupons de desconto, campanhas automáticas e avaliações dos clientes.",
  topicos: [
    {
      pergunta: "Qual a diferença entre promoção e cupom?",
      resposta: "PROMOÇÃO muda o preço do produto no cardápio pra todo mundo (ex.: pizza grande por R$ 49,90 às quartas) — o cliente vê o preço riscado e o novo. CUPOM é um código que o cliente digita no checkout (ex.: BEMVINDO10) — desconto percentual ou fixo, com regras de uso. Ficam em Impulsione suas Vendas → Promoções e → Cupons (um item cada no menu).",
    },
    {
      pergunta: "Que regras posso colocar numa promoção?",
      resposta: "Dias da semana e faixa de horário (ex.: só sexta e sábado à noite), canais onde vale (cardápio, delivery, mesas, balcão, bot), limite total de usos e validade. No caso de pizza, o desconto pode ser por tamanho. A Cleo anuncia as promoções ativas quando o cliente pergunta.",
    },
    {
      pergunta: "Que regras posso colocar num cupom?",
      resposta: "Valor mínimo do pedido, limite de usos total e por cliente, validade, primeira compra apenas, e visibilidade — cupom público aparece como banner no cardápio; cupom secreto só funciona pra quem digitar o código (bom pra divulgar em story ou grupo).",
    },
    {
      pergunta: "O que são as Campanhas?",
      resposta: "Automações de venda em Impulsione suas Vendas → Campanhas. As principais: Sugestões Inteligentes (o \"que tal adicionar?\" do carrinho, que aprende com o que mais sai junto), recuperação de carrinho abandonado e mensagens de aniversário. Cada campanha tem relatório de disparos e conversões.",
      videos: ["syuIlQWTDak"],
    },
    {
      pergunta: "Como funcionam as avaliações?",
      resposta: "Depois do pedido concluído, o cliente recebe o convite pra avaliar (nota e comentário). A nota média aparece no topo do cardápio online, e o Relatório de Avaliações mostra a evolução, os comentários e os pedidos ligados a cada nota.",
      videos: ["ibJuqKi9Sxk"],
    },
    {
      pergunta: "O que é o Indique e Ganhe?",
      resposta: "Programa de indicação entre lojas: quem indica o Núcleo pra outro estabelecimento acumula benefício quando a loja indicada assina. Está marcado como Em breve no menu — a mecânica final será liberada em breve.",
    },
    {
      pergunta: "O que são Agendamentos, marcados como Em breve?",
      resposta: "Agendamentos permite o cliente marcar a entrega pra um horário futuro (ex.: encomendar hoje pra amanhã ao meio-dia). Já está em finalização e aparece bloqueado no menu até a liberação.",
      videos: ["IJTL5dE8NEY"],
    },
  ],
};
